import { BaseDevice } from '@lib/core/model';

import { DeviceBackup } from '../model';

export class BackupMapper {
  public static map(data: any): DeviceBackup {
    return data
      ? new DeviceBackup(
        data.id,
        data.finished,
        data.executionType,
        data.createdAt,
        data.expiresAt,
        data.rangeTo,
        data.type,
        new BaseDevice(
          data.device.id,
          data.device.model,
          data.device.vendor
        )
      )
      : null;
  }
}
